import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { SectionSubTitle, SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import SignupButton from 'pricing-pages-ui/components/common/SignupButton';
import SkeletonLoadWrapper from 'pricing-pages-ui/components/common/loading/SkeletonLoadWrapper';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { FREE_CARD } from '../../v2/constants/tracking/TrackingSources';
// @ts-expect-error svg import
import IlloImg from 'bender-url!./img/illo.svg';
import { Image } from 'foundations-components/transitional/components/Image';
import { useMedia } from 'pricing-pages-ui-components/hooks/useMedia';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HorizontalFreeCard = () => {
  const isAppReady = useGlobalLoading();
  const isTablet = useMedia('tabletPortrait');
  return /*#__PURE__*/_jsx(CardWrapper, {
    maxInlineSize: "1200px",
    margin: "auto",
    borderRadius: "400",
    marginBlock: "800",
    children: /*#__PURE__*/_jsx(CardSection, {
      paddingBlock: "600",
      paddingInline: "800",
      children: /*#__PURE__*/_jsxs(Flex, {
        gap: "900",
        justifyContent: "space-between",
        flexDirection: isTablet ? 'column' : 'row',
        children: [/*#__PURE__*/_jsxs(Flex, {
          justifyContent: "space-between",
          flexGrow: 1,
          children: [/*#__PURE__*/_jsxs(Flex, {
            flexDirection: "column",
            justifyContent: "center",
            maxInlineSize: "500px",
            children: [/*#__PURE__*/_jsx(SectionTitle, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricing-pages-ui.hsoc.merchCards.horizontalFree.title"
              })
            }), /*#__PURE__*/_jsx(SectionSubTitle, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "pricing-pages-ui.hsoc.merchCards.horizontalFree.description"
              })
            })]
          }), /*#__PURE__*/_jsx(Image, {
            src: IlloImg,
            maxInlineSize: "115px",
            borderInlineEndColor: "border-core-default",
            borderInlineEndStyle: "solid",
            borderInlineEndWidth: isTablet ? '0' : '100',
            paddingInlineEnd: isTablet ? '0' : '500'
          })]
        }), /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
            isLoading: !isAppReady,
            heights: [47],
            widths: ['100%'],
            children: /*#__PURE__*/_jsx(SignupButton, {
              sourceId: "pricing-hero",
              use: "secondary",
              nonMerchandiseIdProduct: "crm",
              trackingSource: FREE_CARD
            })
          })
        })]
      })
    })
  });
};